module.exports = __webpack_public_path__ + "img/disconnected.a9d95cb3.png";